import _ from 'lodash';
import {Module, Component} from '../decorators';

import tpl from './price.section.html';


@Module({
    name: "app.compontents.price.table",
})
@Component({
    selector: 'blnd-price-table',
    template: tpl,
    bindings: {
        fertTotalCost: '<',
        productTotalCost: '<',
        isCalculating: '<',
        data: '=',
    },
})
export default class C {
    constructor ($scope, $element) {
        "ngInject";
        this.scope = $scope;
        this.$element = $element;
        this.costPerAcre = 0;
        this.costPerTon = 0;
        this.totalCost = 0;
        this.fertTotalCost = 0;
        this.productTotalCost = 0;
        this.watcher = null;
    }

    $onChanges (changes) {
        this.productTotalCost = this.productTotalCost || 0;
        this.fertTotalCost = this.fertTotalCost || 0;
        if (!this.isCalculating) {
            this.calc();
        }
    }

    calc () {
        let acres = this.data.acres || 0;
        let totalCost = this.fertTotalCost + this.productTotalCost;

        this.costPerAcre = acres === 0 ? 0 : totalCost / acres ;

        let quantity = this.data.quantity || 0;
        if (this.data.water_gallons) {
            quantity = quantity / 2000;
        }

        if (this.productTotalCost) {
            this.totalCost = totalCost;
            this.costPerTon = quantity === 0 ? 0 : this.productTotalCost / quantity + this.fertTotalCost/ quantity;
        } else {
            this.totalCost = this.fertTotalCost;
            this.costPerTon = quantity === 0 ? 0 : this.fertTotalCost / quantity;
        }
    }

    $onInit () {
        let self = this;
        this.watcher = this.scope.$watch(() => self.data.water_gallons, function () {
            self.calc();
        });
    }

    $onDestroy () {
        if (this.watcher) {
            this.watcher();
            this.watcher = null;
        }
        this.$element.remove();
        this.$element = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/price.section.js